/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'

export const blind_gift_homepage = createAsyncThunk(
  'BlindBoxGift/blind_gift_homepage',
  async (p: any, store: any) => {
    const resp = await http.post('/live/gift/blind_gift_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export const bg_homepage = createAsyncThunk(
  'BlindBoxGift/bg_homepage',
  async (p: any, store: any) => {
    const resp = await http.post('/live/gift/bg_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export const blind_rank = createAsyncThunk(
  'BlindBoxGift/blind_rank',
  async (param: {week_offset: number; tab: number}, store: any) => {
    const resp = await http.post('/live/gift/blind_rank', {
      ...store.getState().env.deviceinfo,
      ...param,
    })
    return resp.data.data
  }
)

export const b_rank = createAsyncThunk(
  'BlindBoxGift/b_rank',
  async (param: {week_offset: number; tab: number}, store: any) => {
    const resp = await http.post('/live/gift/b_rank', {
      ...store.getState().env.deviceinfo,
      ...param,
    })
    return resp.data.data
  }
)

interface user_info {
  rank: number
  score: number
  blind_list?: Array<{
    gift_id?: number
    icon?: string
  }>
  member?: any
}
const initialState: {
  home: {
    critical_list?: Array<{
      mid: number
      avatar: string
      coin: number
      name: string
      cnt: number
    }>
    broad_list?: Array<{
      mid: number
      avatar: string
      coin: number
      name: string
      cnt: number
    }>
    list?: Array<{
      gift_list: Array<{
        gift_id: number
        icon: string
        coin: number
        name: string
        blind_level: number
        probability: number
      }>
      blind_gift?: {
        gift_id: number
        icon: string
        coin: number
        name: string
      }
    }>
  }
  rank: {
    list?: Array<user_info>
    own?: user_info
    reward_num?: number
    reward_icon?: string
    count_down?: number
    reelection_cnt?: number
    last_member?: any
  }
} = {
  home: {},
  rank: {},
}

export const BlindBoxGiftSlice = createSlice({
  name: 'BlindBoxGift',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(blind_gift_homepage.fulfilled, (state, action) => {
      Object.assign(state, {home: action.payload})
    })
    builder.addCase(blind_rank.fulfilled, (state, action) => {
      Object.assign(state, {rank: action.payload})
    })

    builder.addCase(bg_homepage.fulfilled, (state, action) => {
      const payload = action.payload || {}
      const list = payload.list || []

      // 接口返回 b_home 字段使用缩写：bl_level、pb
      // 这里在缓存时补充一份全称字段：blind_level、probability，方便与 home 结构互通复用
      const mappedList = _map(list, (item) => ({
        ...item,
        gift_list: _map(item.gift_list, (gift) => ({
          ...gift,
          blind_level:
            typeof gift.blind_level !== 'undefined'
              ? gift.blind_level
              : gift.bl_level,
          probability:
            typeof gift.probability !== 'undefined'
              ? gift.probability
              : gift.pb,
        })),
      }))

      Object.assign(state, {
        home: {
          ...payload,
          list: mappedList,
        },
      })
    })
    builder.addCase(b_rank.fulfilled, (state, action) => {
      const data = action.payload
      if (!data) return

      // 直接在赋值时进行数据映射转换
      const formattedRank = {
        ...data,
        // 转换排行榜列表中的字段
        list: data.list?.map((item) => ({
          ...item,
          blind_list: item.blind_list?.map((gift) => ({
            ...gift,
            blind_level: gift.bl_level ?? gift.blind_level, // 如果有 bl_level 就用，没有就保留原样
            probability: gift.pb ?? gift.probability, // 如果有 pb 就用，没有就保留原样
          })),
        })),
        // 转换“我的排名”中的字段
        own: data.own
          ? {
              ...data.own,
              blind_list: data.own.blind_list?.map((gift) => ({
                ...gift,
                blind_level: gift.bl_level ?? gift.blind_level,
                probability: gift.pb ?? gift.probability,
              })),
            }
          : data.own,
      }

      Object.assign(state, {rank: formattedRank})
    })
  },
})

export const useBlindBoxGift = () => useSelector((store) => store.Animal_Gopher)

export default BlindBoxGiftSlice.reducer
export const BlindBoxGiftActions = BlindBoxGiftSlice.actions
